"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formValidation = void 0;
var _validate = require("./validate");
var _reactGa = _interopRequireDefault(require("react-ga"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var windowGlobal = typeof window !== "undefined" && window;
var formValidation = function formValidation(e, isMobile) {
  var count = 0;
  var errors = false;
  var error_string = "";
  var age = document.querySelector("#age").checked;
  var agreeTerms = document.querySelector("#agreeTerms").checked;
  var videoUrl = document.querySelector("#url").value.replace(/\s/g, "");
  var firstName = document.querySelector("#first_name").value.trim();
  var lastName = document.querySelector("#last_name").value.trim();
  var emailInput = document.querySelector("#email").value.trim();
  var phoneNumber = document.querySelector("#phone").value.trim();
  var country = document.querySelector("#country").value;
  if (isMobile) {
    if (windowGlobal.Upload.type === "upload" && !windowGlobal.Upload.fileName) {
      _reactGa["default"].ga("send", "event", "formError", "Footage not provided");
      error_string += "Video footage must be uploaded before submitting.\n";
      errors = true;
    } else if (windowGlobal.Upload.type === "url" && videoUrl === "") {
      _reactGa["default"].ga("send", "event", "formError", "URL is blank");
      error_string += "Video URL is required.\n";
      errors = true;
    } else if (windowGlobal.Upload.type === null) {
      _reactGa["default"].ga("send", "event", "formError", "Type is blank");
      error_string += "Select 'Upload Video' or 'Provide Link'.\n";
      errors = true;
    }
  } else {
    if (videoUrl === "") {
      _reactGa["default"].ga("send", "event", "formError", "URL is blank");
      error_string += "Video URL is required.\n";
      errors = true;
    }
  }
  if (!(0, _validate.validateUrl)(videoUrl, count) && videoUrl.trim().length > 0) {
    _reactGa["default"].ga("send", "event", "formError", "Invalid Url");
    error_string += "Video URL must be a valid URL.\n";
    errors = true;
  }
  if (firstName === "") {
    _reactGa["default"].ga("send", "event", "formError", "First Name is blank");
    error_string += "First Name field is required.\n";
    errors = true;
  }
  if (firstName.length < 2) {
    _reactGa["default"].ga("send", "event", "formError", "Invalid First Name");
    error_string += "Please enter a valid first name.\n";
    errors = true;
  }
  if (lastName === "") {
    _reactGa["default"].ga("send", "event", "formError", "Last Name is blank");
    error_string += "Last Name field is required.\n";
    errors = true;
  }
  if (lastName.length < 2) {
    _reactGa["default"].ga("send", "event", "formError", "Invalid Last Name");
    error_string += "Please enter a valid last name.\n";
    errors = true;
  }
  if (emailInput === "") {
    _reactGa["default"].ga("send", "event", "formError", "Email is blank");
    error_string += "Email field is required.\n";
    errors = true;
  }
  if (!(0, _validate.validateEmail)(emailInput)) {
    _reactGa["default"].ga("send", "event", "formError", "Invalid Email");
    error_string += "Please enter a valid email address.\n";
    errors = true;
  }
  if (phoneNumber === "") {
    _reactGa["default"].ga("send", "event", "formError", "Phone Number is blank");
    error_string += "Phone Number field is required.\n";
    errors = true;
  }
  if (!(0, _validate.validatePhone)(phoneNumber)) {
    _reactGa["default"].ga("send", "event", "formError", "Invalid Phone Number");
    error_string += "Please enter a valid phone number. Only Numbers, +,-,(,) and space are allowed.\n";
    errors = true;
  }
  if (phoneNumber !== "" && (0, _validate.validatePhone)(phoneNumber)) {
    var number = phoneNumber.replace(/[^0-9.]/g, "");
    if (number.length < 8) {
      _reactGa["default"].ga("send", "event", "formError", "Invalid Phone Number");
      error_string += "Please enter a valid phone number.\n";
      errors = true;
    }
  }
  if (!age) {
    _reactGa["default"].ga("send", "event", "formError", "Age not checked");
    error_string += "You have not warranted that you are 13 years of age or older.\n";
    errors = true;
  }
  if (!agreeTerms) {
    _reactGa["default"].ga("send", "event", "formError", "Terms not checked");
    error_string += "Please indicate that you have read and agree to the Terms of Service and Terms of Submission.\n";
    errors = true;
  }
  if (country === "") {
    _reactGa["default"].ga("send", "event", "formError", "Country is blank");
    error_string += "Country field is required.\n";
    errors = true;
  }
  return {
    errors: errors,
    errorsString: error_string
  };
};
exports.formValidation = formValidation;